import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Chip,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import EditIcon from "@mui/icons-material/EditOutlined";
import CheckIcon from "@mui/icons-material/CheckOutlined";
import { fmtK } from "../utils";

const StatCard = ({
  label,
  value,
  sub,
  subColor,
  editable,
  onEdit,
  darkMode,
}) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState("");

  const startEdit = () => {
    setDraft(String(Math.round(value / 1000)));
    setEditing(true);
  };
  const commitEdit = () => {
    const parsed = parseFloat(draft);
    if (!isNaN(parsed) && parsed >= 0) onEdit(parsed * 1000);
    setEditing(false);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        minWidth: 0,
        p: 2,
        border: "1px solid",
        borderColor: darkMode ? "#333" : "#e0e0e0",
        borderRadius: 2,
        bgcolor: darkMode ? "#1e1e1e" : "#fff",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <Typography
        sx={{
          fontSize: 10,
          fontWeight: 600,
          letterSpacing: 0.8,
          color: darkMode ? "#aaa" : "#888",
          textTransform: "uppercase",
          mb: 0.5,
        }}
      >
        {label}
        {editable && (
          <Chip
            label="EDITABLE"
            size="small"
            sx={{
              ml: 1,
              fontSize: 9,
              height: 16,
              bgcolor: "#1565c0",
              color: "#fff",
            }}
          />
        )}
      </Typography>

      {editing ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Typography
            sx={{
              fontSize: 22,
              fontWeight: 700,
              color: darkMode ? "#fff" : "#111",
            }}
          >
            $
          </Typography>
          <OutlinedInput
            autoFocus
            size="small"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onBlur={commitEdit}
            onKeyDown={(e) => e.key === "Enter" && commitEdit()}
            endAdornment={<InputAdornment position="end">K</InputAdornment>}
            sx={{ width: 120, fontSize: 20, fontWeight: 700 }}
          />
          <IconButton size="small" onClick={commitEdit}>
            <CheckIcon fontSize="small" />
          </IconButton>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            gap: 0.5,
            cursor: editable ? "pointer" : "default",
          }}
          onClick={editable ? startEdit : undefined}
        >
          <Typography
            sx={{
              fontSize: 28,
              fontWeight: 700,
              color: darkMode ? "#fff" : "#111",
            }}
          >
            {fmtK(value)}
          </Typography>
          {editable && (
            <EditIcon sx={{ fontSize: 14, color: "#888", mb: 0.5 }} />
          )}
        </Box>
      )}

      {sub && (
        <Typography
          sx={{
            fontSize: 11,
            color: subColor || (darkMode ? "#aaa" : "#888"),
            mt: "auto",
            pt: 0.5,
          }}
        >
          {sub}
        </Typography>
      )}
    </Paper>
  );
};

export default StatCard;
